/* Oergezond slide cart: upsells met 15% korting (v3.16).
   Welke 3 producten: regel van het belangrijkste product in de winkelmand (lx-ups-map, op basis van wat klanten samen kopen).
   De korting zelf komt van de automatische Shopify-kortingen "15% korting bij je <product>" (koop X, 15% op Y),
   dus wat hier staat is ook wat Shopify rekent. Vervangt de standaard Kaching-upsellcarrousel. */
(function () {
  var cfgEl = document.getElementById('lx-ups-map');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var PCT = CFG.pct, FREE = CFG.freeShip || 5500, cache = {}, cart = null, lastKey = '', busy = false, adding = false;

  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function off(c) { return Math.round(c * (100 - PCT) / 100); }

  function product(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return cache[h];
  }

  /* hoofdproduct = eerste uit de prioriteitslijst dat betaald in de winkelmand zit (gratis cadeaus tellen niet) */
  function anchorOf(c) {
    var paid = {}, inCart = {};
    c.items.forEach(function (i) { inCart[i.handle] = true; if (i.final_line_price > 0) paid[i.handle] = i; });
    for (var k = 0; k < CFG.priority.length; k++) {
      var h = CFG.priority[k];
      if (paid[h] && CFG.rules[h]) return { handle: h, item: paid[h], picks: CFG.rules[h].filter(function (x) { return !inCart[x]; }) };
    }
    return null;
  }

  function firstPrice(p) { var v = p.variants.filter(function (x) { return x.available; })[0]; return v ? v.price : 0; }

  function cardHTML(p, bridge) {
    var vs = p.variants.filter(function (v) { return v.available; });
    if (!vs.length) return '';
    var v = vs[0];
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var sel = vs.length > 1
      ? '<select class="lx-ups__sel" aria-label="Kies ' + esc(p.options[0] && p.options[0].name || 'variant') + '">' +
        vs.map(function (x) { return '<option value="' + x.id + '" data-price="' + x.price + '">' + esc(x.title) + '</option>'; }).join('') + '</select>'
      : (p.variants.length > 1 ? '<span class="lx-ups__var">' + esc(v.title) + '</span>' : '');
    return '<li class="lx-ups__item" data-id="' + v.id + '">' +
      '<span class="lx-ups__img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
      '<span class="lx-ups__body">' + (bridge ? '<span class="lx-ship lx-ups__ship"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>Gratis verzending</span>' : '') + '<span class="lx-ups__name">' + esc(p.title) + '</span>' + sel +
      '<span class="lx-ups__price"><s>' + eur(v.price) + '</s> <b data-now>' + eur(off(v.price)) + '</b> <i>-' + eur(v.price - off(v.price)) + '</i></span></span>' +
      '<button type="button" class="lx-ups__add" aria-label="' + esc(p.title) + ' toevoegen met ' + eur(v.price - off(v.price)) + ' korting"><svg class="lx-ups__plus" viewBox="0 0 18 18" aria-hidden="true"><path d="M9 3.5v11M3.5 9h11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><svg class="lx-ups__ok" viewBox="0 0 18 18" aria-hidden="true"><path d="m4 9.4 3.2 3.2L14 5.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button></li>';
  }

  function mount(root) {
    var box = root.querySelector('.lx-ups');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'lx-ups';
    box.hidden = true;
    var k = root.querySelector('.kaching-upsell-module--product-upsell');
    if (k) { k.before(box); return box; }
    var items = root.querySelectorAll('.kaching-cart-item');
    if (items.length) { var last = items[items.length - 1]; (last.parentElement || last).after(box); return box; }
    var foot = root.querySelector('.kaching-cart__footer');
    if (foot) { foot.before(box); return box; }
    return null;
  }

  function render() {
    var root = document.querySelector('.kaching-cart');
    if (!root || !cart) return;
    var box = mount(root);
    if (!box) return;
    var a = cart.items.length ? anchorOf(cart) : null;
    if (!a || !a.picks.length) { box.hidden = true; box.innerHTML = ''; box.dataset.key = ''; return; }
    var key = a.handle + ':' + a.picks.join(',') + ':' + (cart.total_price >= FREE ? 'f' : cart.total_price);
    if (box.dataset.key === key && box.innerHTML) { box.hidden = false; return; }
    box.dataset.key = key;
    Promise.all(a.picks.slice(0, 3).map(product)).then(function (ps) {
      if (box.dataset.key !== key) return;
      ps = ps.filter(function (p) { return p && firstPrice(p) > 0; });
      /* gratis verzending: zet de goedkoopste upsell die je over de grens tilt bovenaan */
      var gap = FREE - cart.total_price, bridge = null;
      if (gap > 0) {
        ps.forEach(function (p) { if (off(firstPrice(p)) >= gap && (!bridge || firstPrice(p) < firstPrice(bridge))) bridge = p; });
        if (bridge) ps = [bridge].concat(ps.filter(function (p) { return p !== bridge; }));
      }
      /* label op elk product dat de verzending gratis maakt */
      var html = ps.map(function (p) { return cardHTML(p, gap > 0 && off(firstPrice(p)) >= gap); }).join('');
      if (!html) { box.hidden = true; return; }
      var sub = gap > 0 ? 'Nog ' + eur(gap) + ' tot gratis verzending.' : 'Omdat je ' + esc(a.item.product_title) + ' bestelt.';
      box.innerHTML =
        '<p class="lx-ups__k">Alleen in je winkelmand</p>' +
        '<p class="lx-ups__h">Pak er iets bij <b>met korting</b></p>' +
        '<p class="lx-ups__s">' + sub + '</p>' +
        '<ul class="lx-ups__list">' + html + '</ul>';
      box.hidden = false;
    });
  }

  function load() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); }).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.lx-ups__sel');
    if (!s) return;
    var li = s.closest('.lx-ups__item'), o = s.selectedOptions[0];
    li.dataset.id = s.value;
    var price = +o.dataset.price;
    li.querySelector('s').textContent = eur(price);
    li.querySelector('[data-now]').textContent = eur(off(price));
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lx-ups__add');
    if (!b || adding) return;
    var li = b.closest('.lx-ups__item');
    adding = true; b.disabled = true; b.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +li.dataset.id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      b.classList.remove('is-busy'); b.setAttribute('aria-label', 'Toegevoegd');
      li.classList.add('is-added');
      var api = window.kachingCartApi;
      return api && typeof api.refreshCart === 'function' ? api.refreshCart() : null;
    }).catch(function () {
      b.disabled = false; b.classList.remove('is-busy');
    }).then(function () { adding = false; lastKey = ''; setTimeout(load, 300); });
  });

  /* volg de winkelmand: Kaching tekent opnieuw bij elke wijziging */
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    setTimeout(function () {
      q = false;
      var root = document.querySelector('.kaching-cart');
      if (!root) return;
      var sub = root.querySelector('.kaching-cart__subtotal');
      var key = (sub ? sub.textContent : '') + '|' + root.querySelectorAll('.kaching-cart-item').length;
      if (key !== lastKey) { lastKey = key; load(); } else render();
    }, 200);
  }).observe(document.body, { childList: true, subtree: true });
})();
